interface ListItemDescriptor
{
	content: Array<string|HTMLElement|JQuery<HTMLElement>>;
	id?: string;
	classes?: string[];
}

class ListField
{

	protected m_Root: HTMLElement;
	private		m_Item: string;
	private		m_Count: number;

	constructor(
		typ_: string,
		item: string,
	)
	{
		this.m_Root		= document.createElement( typ_ );
		this.m_Item		= item;
		this.m_Count	= 0;

		$( this.m_Root ).addClass( 'list-group' );
	}

	public getElement() : HTMLElement
	{
		return this.m_Root;
	}

	public isEmpty(): boolean
	{
		return this.m_Count == 0;
	}

	public getCount(): number
	{
		return this.m_Count;
	}

	public addItem( descriptor?: ListItemDescriptor ): JQuery<HTMLElement>
	{
		const item = $( document.createElement( this.m_Item ) );

		item.addClass( 'list-group-item' );

		$( this.m_Root ).append( item );

		if ( descriptor )
		{
			if ( descriptor.id )
			{
				item.attr( 'id', descriptor.id );
			}

			if ( descriptor.classes )
			{
				for ( const i in descriptor.classes )
				{
					item.addClass( 'list-group-item-' + descriptor.classes[ i ] );
				}
			}

			for ( const i in descriptor.content )
			{
				item.append( descriptor.content[ i ] );
			}
		}

		++this.m_Count;

		return item;
	}

}

class UList
	extends ListField
{
	public constructor()
	{
		super( 'ul', 'li' );
	}
}

class OList
	extends ListField
{
	public constructor()
	{
		super( 'ol', 'li' );
	}
}

class DivList
	extends ListField
{
	public constructor()
	{
		super( 'div', 'div' );
	}
}
